export class DeviceModel {
    deviceType = 3; //web
    deviceNo = Math.random().toString(36).substr(2);
    registrationId = '';
    guiVersion = '1';
    isIosSandBox = false;
}
